import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {DropdownEditorComponent} from '@irb-common/components/grid/editors/dropdown-editor.component';
import {DropdownRendererComponent} from '@irb-common/components/grid/renderers/dropdown.cell.component';
import {TruncateTooltipCellComponent} from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import {ImportSecurityCategorySecuritiesDialogComponent} from './import-security-category-securities-dialog.component';
import { DropdownFilterRendererComponent } from '@irb/irb-common/components/grid/renderers/dropdown-filter.cell.component';
import { IDropdownItem } from '@irb/irb-common/models/dropdown.model';
import { NumberTextBoxRendererComponent } from "@irb-common/components/grid/renderers/number-text-box.cell.component";

@Injectable({
    providedIn: 'root'
})
export class ImportSecurityCategoryUnrecognizedGridLayoutService implements GridLayoutService<ImportSecurityCategorySecuritiesDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "DropdownEditorComponent": DropdownEditorComponent,
            "DropdownFilterRendererComponent": DropdownFilterRendererComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "NumberTextBoxRendererComponent": NumberTextBoxRendererComponent,
        };
    }

    getColumnDefs(parent: ImportSecurityCategorySecuritiesDialogComponent) {
        return [{
            headerName: 'Select All',
            colId:'selectAll',
            headerComponent: 'customHeader',
            cellRenderer : 'customHeader',
            cellRendererParams: {parentObject: parent, type: 'rowCheckBox' },
            suppressColumnsToolPanel: true,
            suppressSizeToFit: true,
            toolPanelClass: 'toolpanel-header-checkbox-hide',
            headerComponentParams: {parentObject: parent, type: 'headerCheckBox',cbSelectAllInpChecked:true },
            suppressMovable: true,
            lockPosition: true,
            lockVisible: true,
            sortable: false,
            filter: true,
            resizable: false,
            minWidth: 25,
            width: 25,
            maxWidth:25,
            cellStyle: {'padding' : '5px 3px 0 2px'},
            headerClass: 'customHeaderClassSelectAll',
            cellClass: 'selectAllCheckBoxRecord'
            
        },{
            headerName: 'Symbol/CUSIP',            
            field: 'securitySymbol',
            minWidth: 100,
            width: 130
        },
        {
            headerName: 'Description',
            field: 'securityDescription',
            maxWidth: 371,
            cellRenderer: "TruncateTooltipCellComponent",
            cellRendererParams: {
                placeholder: "Description (optional)"
            },
            editable: true
        },
        {
            headerName: 'Type',
            field: 'securityType',
            maxWidth: 130,
            width: 130,
            cellClass: 'dropdownFilterCell',
            cellRenderer : 'DropdownFilterRendererComponent',
            cellRendererParams:(params : any) => {
               return{ defaultValue: {value:params.data.securityType, name:this.optionSecurityTypeGetter(params.data.securityType)},
                values: parent.securityTypes,
                onChange: (params: any, item: IDropdownItem) => {
                    params.data.securityType = item.value;
                    params.api.redrawRows({ rowNodes: [params.node] });
                    return !params.data.securityType && !parent.isValidToContinue;
                  },
                  onClearSelection: (params: any) => {
                    params.data.securityType = "Select";
                    params.api.redrawRows({ rowNodes: [params.node] });
                  }
            }},
            cellClassRules: {
                'grid-cell-invalid': (params: any) => {
                    return !params.data.securityType && !parent.isValidToContinue;
                }
            }
        },
        {
            headerName: 'Custom Category',
            field: 'customCategoryId',
            maxWidth: 160,
            width: 160,
            colId: "custCategoryCol",
            cellRenderer : 'DropdownFilterRendererComponent',
            cellRendererParams: {
                values: parent.securitiesCustomCategories,
                defaultValue: {"id": 0, "name": "Uncategorized"},
                onChange: (params: any, item: IDropdownItem) => {
                    params.data.customCategoryId = item.value;
                },
                onClearSelection: (params: any) => {
                    params.data.customCategoryId = "0";
                    params.api.redrawRows({ rowNodes: [params.node] });
                },
                identifier: "id"
            },
            cellClass: 'dropdownFilterCell',
        },
        {
            headerName: 'External Share Price',
            field: 'externalSharePrice',
            minWidth: 100,
            width: 140,
            //cellRenderer: 'cellRendererFormatter',
            //cellRendererParams: { type: 'currency', decimalPosition: '2' },
            //editable: this.canEdit.bind(this),
            valueGetter: this.getActionValue.bind(this),
            cellClass: 'numberTextBoxCell',
            cellRenderer: 'NumberTextBoxRendererComponent',
            cellRendererParams: (params: any) => { return {
                min: 1,
                places: 2,
                isCurrency:true,
                isNotApplicable:!(params.data.securityType === "EXTERNAL"),
                invalidMessage: 'The value entered is not valid.',
                invalidRangeMessage: 'Value can not be negative or zero.',
                disabled: !this.canEdit(params),
                onChange: (params: any, c: any) => {
                    const currentValue = Number(c.value);
                    if (params.data.externalSharePrice != currentValue && currentValue) {
                      params.data.externalSharePrice = currentValue;
                      params.api.redrawRows({ rowNodes: [params.node] });
                    }
                  },
            }},
            /* valueSetter: (params: any) => {
                params.data.externalSharePrice = (isNaN(params.newValue)) ? 1 : parseFloat(params.newValue);
                return true;
              }*/

        },];
    }

 
    getActionValue(params: any) {
        if (params.data.securityType === "EXTERNAL") {
            if (params.data.externalSharePrice === null || params.data.externalSharePrice === undefined || params.data.externalSharePrice===0) {
                params.data.externalSharePrice = 1;
                return 1;
            }
            else {
                return params.data.externalSharePrice;
            }
        } else {
            return 'n/a';
        }
    }

    canEdit(params:any) {
        if(params.data.securityType === "EXTERNAL") {
            return true;
        } else {
            return false;
        }
      }
      optionSecurityTypeGetter(value: any) {
        if (value) {
          switch (value) {
            case "NONE":
              return "Select";
            case "GROUP":
              return "Group";
            case "OTHER":
              return "Other";
            case "SMA":
              return "SMA";
            case "EXTERNAL":
                return "External";
            default:
                return "Select";
          }
        }
       
      }
}
